<mp-root-module-nav *mpHeaderElement="'left'" label="Sortimente" />

<mp-overview
  class="overview"
  moduleTitle="Sortimente"
  [isCustomHeader]="true"
  [resultCount]="resultCount$ | async"
  (searched)="handleSearch($event)"
>
  <button mat-menu-item routerLink="create">Neu</button>

  <mp-infinite-scroll
    [itemHeight]="86"
    [itemTemplate]="itemTemplate"
    [dataSource]="dataSource"
    [scrollThresholdShare]="1"
  />

  <ng-template #itemTemplate let-articleRange>
    <mp-overview-item [path]="articleRange.articleRangeId">
      <div class="overview-item">
        <div class="overview-item__content">
          <h2 class="truncate" [title]="articleRange.name">{{ articleRange.name }}</h2>

          <div class="overview-item__organization-count">
            <mat-icon svgIcon="bank_outline" />
            {{ articleRange.organizationCount }}
          </div>
        </div>
      </div>

      <button mat-menu-item (click)="deleteArticleRange(articleRange)">Sortiment löschen</button>
    </mp-overview-item>
  </ng-template>
</mp-overview>
